// GlobalFooter - Footer unifié AbracadaWorld
// Design sombre premium avec liens de navigation, bandeau Beta et copyright

import { Link, useLocation } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

export default function GlobalFooter() {
  const location = useLocation();
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  
  // Pages où le footer est AFFICHÉ sur mobile (whitelist)
  const mobileFooterWhitelist = [
    '/',                    // Page d'accueil AbracadaWorld
    '/abracadaworld',       // Page d'accueil alternative
    '/blog',                // Blog
  ];
  
  // Vérifier si on est sur une page whitelist ou un article de blog
  const isWhitelisted = mobileFooterWhitelist.includes(location.pathname) || 
                        location.pathname.startsWith('/blog/');
  
  // Pages plein écran isolées : pas de footer du tout
  if (location.pathname === '/decrire-projet') return null;

  // Sur mobile : masquer le footer sauf sur les pages whitelistées
  if (isMobile && !isWhitelisted) {
    return null;
  }
  
  return (
    <footer style={{ 
      background: 'linear-gradient(165deg, #072B57 0%, #103A6D 35%, #1D4E89 70%, #072B57 100%)'
    }} className="text-white" data-testid="global-footer">
      
      {/* Main Footer */}
      <div className="max-w-6xl mx-auto px-4 py-10 sm:py-16">
        {/* Logo & Description */}
        <div className="text-center sm:text-left mb-8">
          <Link to="/abracadaworld" className="flex items-center justify-center sm:justify-start gap-2 mb-4">
            <img 
              src="/logo-abracadaworld-transparent.png" 
              alt="AbracadaWorld"
              className="h-12 w-auto"
            />
          </Link>
          <p className="text-slate-300 text-sm mb-6">
            Le 1er centre commercial virtuel. 21 univers thématiques. Sans commission, sans intermédiaire.
          </p>
          
          {/* BANDEAU BETA */}
          <div className="text-center p-4 rounded-xl mb-8" style={{ background: 'linear-gradient(135deg, #FFF8F4 0%, #FFEEE4 100%)' }}>
            <p className="text-amber-600 font-bold text-sm mb-1">Version BETA - Test</p>
            <p className="text-slate-600 text-xs leading-relaxed">
              AbracadaWorld est actuellement en version Beta. <strong className="text-amber-600">Aucune transaction réelle n'est possible pour le moment.</strong> Les fonctionnalités de paiement et de vente seront activées lors de l'ouverture officielle prévue le 1er Juillet 2026.
            </p>
          </div>
        </div>
        
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-8">
          
          {/* Navigation */}
          <div>
            <h4 className="font-semibold text-white mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li><Link to="/artisans" className="text-slate-300 hover:text-orange-400 text-sm transition-colors">Artisans</Link></li>
              <li><Link to="/produits" className="text-slate-300 hover:text-orange-400 text-sm transition-colors">Marketplace</Link></li>
              <li><Link to="/particuliers" className="text-slate-300 hover:text-orange-400 text-sm transition-colors">Petites annonces</Link></li>
              <li><Link to="/emploi" className="text-slate-300 hover:text-orange-400 text-sm transition-colors">Emploi</Link></li>
              <li><Link to="/reseau" className="text-slate-300 hover:text-orange-400 text-sm transition-colors">Réseau social</Link></li>
            </ul>
          </div>
          
          {/* Pour les Pros */}
          <div>
            <h4 className="font-semibold text-white mb-4">Pour les Pros</h4>
            <ul className="space-y-2">
              <li><Link to="/pro/fondateur" className="text-slate-300 hover:text-orange-400 text-sm transition-colors">Offre Fondateur</Link></li>
              <li><Link to="/pro/membres-fondateurs" className="text-orange-400 hover:text-orange-300 text-sm transition-colors font-medium">Membres Fondateurs</Link></li>
              <li><Link to="/pro" className="text-slate-300 hover:text-orange-400 text-sm transition-colors">Espace Pro</Link></li>
              <li><Link to="/reseau-pros" className="text-slate-300 hover:text-orange-400 text-sm transition-colors">Réseau Pros</Link></li>
              <li><Link to="/decrire-projet" className="text-slate-300 hover:text-orange-400 text-sm transition-colors">Décrire un projet</Link></li>
            </ul>
          </div>
          
          {/* Légal */}
          <div>
            <h4 className="font-semibold text-white mb-4">Informations</h4>
            <ul className="space-y-2">
              <li><Link to="/mentions-legales" className="text-slate-300 hover:text-orange-400 text-sm transition-colors">Mentions légales</Link></li>
              <li><Link to="/cgv" className="text-slate-300 hover:text-orange-400 text-sm transition-colors">CGV</Link></li>
              <li><Link to="/cgu" className="text-slate-300 hover:text-orange-400 text-sm transition-colors">CGU</Link></li>
              <li><Link to="/politique-confidentialite" className="text-slate-300 hover:text-orange-400 text-sm transition-colors">Confidentialité</Link></li>
              <li><Link to="/contact" className="text-slate-300 hover:text-orange-400 text-sm transition-colors">Contact</Link></li>
            </ul>
          </div>
        </div>
      </div>
      
      {/* Bottom Bar - Copyright */}
      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-4 py-4 sm:py-6">
          {/* Copyright */}
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
            <p className="text-slate-400 text-xs">
              © 2025-2026 AbracadaWorld. Tous droits réservés.
            </p>
            <p className="text-slate-400 text-xs">
              Site en version Beta - Aucune transaction disponible
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
